import React from 'react'
import Layout from '../../../Layout'
import EditDriverContainer from '../../../../../Components/UserPart/EditUser/Driver/EditDriverContainer'

const EditDriver = () => {
  return (
    <Layout>
      <EditDriverContainer/>
    </Layout>
  )
}

export default EditDriver